import { render, staticRenderFns } from "./UploadImgAndFile.vue?vue&type=template&id=760ac564&scoped=true"
import script from "./UploadImgAndFile.vue?vue&type=script&lang=ts"
export * from "./UploadImgAndFile.vue?vue&type=script&lang=ts"
import style0 from "./UploadImgAndFile.vue?vue&type=style&index=0&id=760ac564&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760ac564",
  null
  
)

export default component.exports